import axios from "axios";

const URL = process.env.REACT_APP_API_URL;

const buildConfig = (method, path, data = undefined, controller = null) => {
    var config = {
        cancelToken: controller?.token,
        method: method,
        url: `${URL}${path}`,
        headers: {

            "Access-Control-Allow-Origin": "*",
        },
        data: data,
    };
    return config;
};

const makeRequest = (config, onSuccess, onError, retry) => {
    axios(config)
        .then(function (response) {
            onSuccess(response);
        })
        .catch(function (error) {
            if (error.code === "ERR_CANCELED") {
                return;
            }
            else {
                onError(error);
            }
        });
};
export const GET = (
    path,
    onSuccess,
    onError,
    retry = true,
    controller = null
) => {
    controller?.cancel();

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const config = buildConfig("GET", path, undefined, source);
    makeRequest(config, onSuccess, onError, retry);

    return source;
};

export const POST = (
    path,
    data,
    onSucces,
    onError,
    retry = true,
    controller = null
) => {
    controller?.cancel();

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const config = buildConfig("POST", path, data, source);
    makeRequest(config, onSucces, onError, retry);

    return source;
};